'use client'

import { HeroSection } from '@/components/marketing/hero-section'
import { ValuesSection } from '@/components/marketing/values-section'
import { CompanyInfoSection } from '@/components/marketing/company-info-section'
// import { ThreePillars } from '@/components/marketing/three-pillars'

// Note: Original code commented out ThreePillars and SocialProof. 
// I will just render the sections I extracted.

export function HomeContent() {
  return (
    <div className="flex flex-col">
      <HeroSection />

      {/* 3本柱セクション */}
      {/* <ThreePillars /> */}

      {/* 実績・社会的証明セクション */}
      {/* <SocialProof /> */}

      <ValuesSection />

      <CompanyInfoSection />
    </div>
  )
}

